module.exports = __webpack_public_path__ + "img/motorbikeFrontLeft.ba71dadc.svg";